import React from 'react'
import './App.css';
import Home from './Components/Home';
import Header from './Components/Header';
function App() {
  return (   
     <div>
      <Header/>
      <Home/>
     </div>
  )
}

export default App